export const convertTableStateToQuery = (tableState) => {
  const filters = Array.isArray(tableState?.columnFilters)
    ? tableState.columnFilters.reduce((acc, { id, value }) => {
        acc[id] = value
        return acc
      }, {})
    : {}

  const sortBy = Array.isArray(tableState?.sorting) && tableState.sorting.length > 0 ? tableState.sorting[0]?.id : ''
  const orderBy =
    Array.isArray(tableState?.sorting) && tableState.sorting.length > 0 ? (tableState.sorting[0]?.desc ? -1 : 1) : 1
  return {
    page: tableState?.pagination?.pageIndex ? tableState?.pagination?.pageIndex + 1 : 1,
    pageSize: tableState?.pagination?.pageSize ?? 10,
    sortBy: sortBy,
    orderBy: orderBy,
    filters: filters,
  }
}
